export default {
    cleanSentence (sentence) {
        
        return sentence
    }
}